/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

export const defaultAttributePreset = [
  'firstname',
  'lastname',
  'city',
  'company',
  'country_code',
  'region',
  'region_code',
  'region_id',
  'telephone',
  'id',
  'vat_id',
  'postcode',
  'street',
  'street_multiline_2',
  'default_shipping',
  'default_billing',
  'fax',
  'prefix',
  'suffix',
  'middlename',
];

export const defaultAccountAttributePreset = [
  'email',
  'firstname',
  'lastname',
  'middlename',
  'gender',
  'dob',
  'prefix',
  'suffix',
  'fax',
];
